import { T, useGT } from 'gt-react';
import { ToggleGroup, ToggleGroupItem } from 'src/components/ui/toggle-group';

export function TaskTimelineViewSwitch({
  view = 'summary',
  onChange,
}: {
  view?: 'summary' | 'events';
  onChange?: (view: 'summary' | 'events') => void;
}) {
  const gt = useGT();
  if (!onChange) return null;
  function select(next: string) {
    if (next === 'summary' || next === 'events') onChange?.(next);
  }
  return (
    <ToggleGroup
      type="single"
      size="sm"
      value={view}
      onValueChange={select}
      className="mb-2 shrink-0"
      aria-label={gt('Timeline view', {
        context: 'task timeline presentation switch',
      })}
    >
      <ToggleGroupItem value="summary">
        <T context="task timeline view option">Summary</T>
      </ToggleGroupItem>
      <ToggleGroupItem value="events">
        <T context="task timeline view option">All Events</T>
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
